const features = [
  'Calendar reading across any platform',
  'Conference bridge join — before the meeting starts',
  'Persistent direct phone callback — retries until answered',
  'Silent mute-join via your bridge',
  'Cancel retry with one button press',
  'Unlimited monthly bridge minutes',
];

interface DialBackPricingProps {
  onGetAccess: () => void;
}

export default function DialBackPricing({ onGetAccess }: DialBackPricingProps) {
  return (
    <section
      className="py-28 px-12 border-t border-white/[0.06] max-md:px-6 max-md:py-20"
      style={{ background: '#0e0d0b', fontFamily: "'Instrument Sans', sans-serif" }}
    >
      <div className="max-w-[860px] mx-auto text-center">
        <div
          className="flex items-center justify-center gap-3 mb-4"
          style={{ fontFamily: "'DM Mono', monospace", fontSize: '11px', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#c8472a' }}
        >
          <span className="block w-6 h-px bg-[#c8472a]" />
          Introductory offer
          <span className="block w-6 h-px bg-[#c8472a]" />
        </div>

        <h2
          className="font-light leading-[1.1] text-[#f5f2ec] text-center"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}
        >
          Simple. One thing. Done right.
        </h2>

        <div className="flex justify-center mt-14">
          <div
            className="bg-[#f5f2ec] text-[#0e0d0b] rounded-[4px] p-12 max-w-[480px] w-full text-left relative overflow-hidden max-md:p-8"
          >
            {/* Top accent bar */}
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-[#c8472a]" />

            <div
              className="mb-1 text-[#9a9488]"
              style={{ fontFamily: "'DM Mono', monospace", fontSize: '10px', fontWeight: 500, letterSpacing: '0.2em', textTransform: 'uppercase' }}
            >
              Dial-Back · Starter · Beta
            </div>
            <div
              className="text-[#0e0d0b] mb-1"
              style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: '1.1rem', fontWeight: 600 }}
            >
              Unlimited Dial-Back
            </div>
            <div
              className="leading-none my-2"
              style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: '4rem', fontWeight: 300, color: '#0e0d0b' }}
            >
              <sup className="text-[1.5rem] align-super">$</sup>49
              <sub className="text-[1rem] text-[#9a9488] font-sans font-normal">/month</sub>
            </div>

            <p className="text-[0.9rem] text-[#6b6560] my-5 leading-[1.65]">
              Beta pricing while we build. Locked in for life for early subscribers. No credit card required to express interest.
            </p>

            <ul className="list-none mb-8 space-y-0">
              {features.map((f, i) => (
                <li
                  key={i}
                  className="flex items-start gap-2 text-[0.88rem] text-[#0e0d0b] py-2 border-b border-black/[0.06] last:border-b-0 leading-[1.45]"
                >
                  <span className="text-[#c8472a] text-[0.82rem] pt-[1px] flex-shrink-0">→</span>
                  {f}
                </li>
              ))}
            </ul>

            <button
              onClick={onGetAccess}
              className="block w-full text-center text-[13px] font-semibold tracking-[0.1em] uppercase text-[#f5f2ec] bg-[#0e0d0b] py-4 rounded-sm transition-colors duration-200 hover:bg-[#c8472a] whitespace-nowrap cursor-pointer"
            >
              Get early access
            </button>

            <p
              className="text-center mt-4 text-[#9a9488]"
              style={{ fontFamily: "'DM Mono', monospace", fontSize: '11px', letterSpacing: '0.04em' }}
            >
              Recording &amp; summary notes — pricing coming soon based on your input
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
